export default __webpack_public_path__ + "static/media/location.dd0b5e50.svg";